import styled from 'styled-components';
import { toggleStyledComponent } from '../internal/utils/toggleStyledComponent.js';
import React from 'react';
import classes from './_TokenTextContainer.module.css.js';
import '../FeatureFlags/FeatureFlags.js';
import { useFeatureFlag } from '../FeatureFlags/useFeatureFlag.js';
import '../FeatureFlags/DefaultFeatureFlags.js';
import { clsx } from 'clsx';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS_MODULES_FEATURE_FLAG = 'primer_react_css_modules_ga';
const StyledTokenTextContainer = toggleStyledComponent(CSS_MODULES_FEATURE_FLAG, 'span', styled('span').withConfig({
  displayName: "_TokenTextContainer__StyledTokenTextContainer",
  componentId: "sc-6l9eri-0"
})(["flex-grow:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;background:transparent;border:none;color:inherit;font:inherit;margin:0;padding:0;width:auto;-webkit-font-smoothing:inherit;-moz-osx-font-smoothing:inherit;-webkit-appearance:none;line-height:normal;color:currentColor;text-decoration:none;&:is(a,button,[tabIndex='0']){cursor:pointer;&:after{content:'';position:absolute;left:0;top:0;right:0;bottom:0;}}"]));
const TokenTextContainer = ({
  children,
  ...props
}) => {
  const enabled = useFeatureFlag(CSS_MODULES_FEATURE_FLAG);
  return /*#__PURE__*/React.createElement(StyledTokenTextContainer, _extends({
    className: clsx(enabled && classes.TokenTextContainer)
  }, props), children);
};
TokenTextContainer.displayName = "TokenTextContainer";

export { TokenTextContainer as default };
